import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SpinnerVariantProps, spinnerVariants } from './spinner.variants';

@Component({
  selector: 'lib-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    '[attr.aria-label]': 'ariaLabel()',
    '[class]': 'classes()',
  },
})
export class SpinnerComponent {
  protected readonly bars = Array.from({ length: 12 }, (_, index) => index);

  readonly size = input<SpinnerVariantProps['size']>('md');
  readonly variant = input<SpinnerVariantProps['variant']>('primary');
  readonly class = input('');
  readonly ariaLabel = input('Loading');

  protected readonly classes = computed(() =>
    [
      spinnerVariants({
        size: this.size(),
        variant: this.variant(),
      }),
      this.class(),
    ]
      .filter(Boolean)
      .join(' ')
  );
}
